import React from 'react'
import { SobreNosotrosUi } from '../../ui/SobreNosotrosUi/SobreNosotrosUi'
import { Header } from '../Header/Header'

export const SobreNosotrosLayouts = () => {
  return (
    <div>
        <Header/>
        <SobreNosotrosUi/>
    </div>
  )
}
